// Copyright (c) 2019 Deere & Company

import { IntlProvider } from 'react-intl';
import { connect } from 'react-redux';

const getStateToBindToContainerProps = () => ( {
    locale: 'EN',
} );

export default connect( getStateToBindToContainerProps )( IntlProvider );
